import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectProfitData } from '../../../selectors/selectProfit';
import { IHowToEarnSchema } from '../../../repositories/price-estimator/entities/how_to_earn/HowToEarnSchema';
import { IProfitItemLayout } from '../../../components/ProfitItem';
import { HelpByCian } from '../../../components/HelpByCian';
import { useIsDesktop } from '@cian/valuation-utils-component';
import {
  trackAgentFormClick,
  trackButtonClick,
  trackCloseHelpModal,
  trackDetailsClick,
  trackNewOfferClick,
  trackShowHelpModal,
} from '../utils/tracking';

export const useDepositProps = (): IProfitItemLayout | null => {
  const isDesktop = useIsDesktop();

  const [isDetailsShow, setIsDetailsShow] = React.useState(false);
  const [isSaleByCianOpen, setOpen] = React.useState(false);

  const profitData = useSelector(selectProfitData) as IHowToEarnSchema;
  const { deposit } = profitData;

  const detailsItems: IProfitItemLayout['detailsItems'] = [];

  if (deposit?.estimationPrice) {
    detailsItems.push({
      title: 'Оценка стоимости',
      value: deposit.estimationPrice,
    });
  }

  if (deposit?.rate) {
    detailsItems.push({
      title: 'Ставка актуальная на',
      value: deposit.rate,
    });
  }

  const saleByCianOpenHandler = React.useCallback(() => {
    setOpen(true);
    trackButtonClick('goSellToDeposit');
  }, []);
  const saleByCianCloseHandler = React.useCallback(() => {
    setOpen(false);
    trackCloseHelpModal('CloseSellWCianPopup');
  }, []);

  const openAgentForm = React.useCallback(() => {
    trackAgentFormClick('SellWAgentPopup');
    window.open('https://www.cian.ru/application-form/', '_blank');
  }, []);
  const openNewOffer = React.useCallback(() => {
    trackNewOfferClick('SellMyselfPopup');
    window.open('https://www.cian.ru/new-offer/', '_blank');
  }, []);

  const handleClick = React.useCallback(() => {
    setIsDetailsShow(!isDetailsShow);
    trackDetailsClick('detailedSellToDeposit');
  }, [isDetailsShow, setIsDetailsShow]);

  if (!deposit) {
    return null;
  }

  return {
    isDesktop,
    title: 'Продать и открыть депозит',
    description: 'Превратите квартиру во вклад и получайте доход по процентам',
    wrapperDescription: 'Доход',
    income: deposit.income,
    percentForYear: deposit.percentForYear,
    details: deposit.details,
    detailsItems,
    additionalInfo: deposit.additionalInfo,
    showDetails: isDetailsShow,
    onClick: handleClick,
    buttonText: 'Продать квартиру с Циан',
    onButtonClick: saleByCianOpenHandler,
    modalComponent: (
      <HelpByCian
        isDesktop={isDesktop}
        isOpen={isSaleByCianOpen}
        onClose={saleByCianCloseHandler}
        headingTitle="Продать квартиру с Циан"
        agentTitle="С риелтором"
        agentDescription="Риелтор партнёр Циан проведёт сделку за вас"
        openAgentForm={openAgentForm}
        openNewOffer={openNewOffer}
        onModalShow={() => trackShowHelpModal('SellWCianPopup')}
      />
    ),
  };
};
